import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import store from './store/store';
import { Provider } from 'react-redux';
import Login from './routes/auth/login';
import dashboard from './routes/dashboard/index';
import ForgotPassword from './routes/auth/forgot-password';
import ResetPassword from './routes/auth/reset-password';
import CheckEmail from './routes/auth/checkemail';
import EmailConfirmation from './routes/auth/email-confirmation';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Registration from './routes/auth/registration';
import PrivateRouter from './routes/privateRouter';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import ReduxToastr from 'react-redux-toastr';
import CssBaseline from '@material-ui/core/CssBaseline';

ReactDOM.render(
  <React.StrictMode>
    <CssBaseline />
    <Provider store={store}>
      <Router>
        <Route path="/" exact component={Login} />
        <PrivateRouter path="/dashboard" component={dashboard} />
        <Route path="/register" exact component={Registration} />
        <Route path="/forgot-password" exact component={ForgotPassword} />
        <Route path="/reset-password" exact component={ResetPassword} />
        <Route path="/check-email" exact component={CheckEmail} />
        <Route path="/auth/email-confirmation" exact component={EmailConfirmation} />
      </Router>
      <ReduxToastr timeOut={5000} progressBar />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);
